import {
  Component,
  Output,
  EventEmitter,
  Inject,
  PLATFORM_ID,
  OnInit
} from '@angular/core';
import { GovernoratesService } from '../../../../../services/governorates.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { UserAddresses } from '../../../../../services/userAddresses';
import { Address } from '../../../../../interfaces/address';
import { Router } from '@angular/router';
import { isPlatformBrowser, Location } from '@angular/common';

@Component({
  selector: 'app-addaddress',
  templateUrl: './addaddress.component.html',
  styleUrl: './addaddress.component.scss'
})
export class AddaddressComponent implements OnInit {

  @Output() fees = new EventEmitter<any>();

  deliveryFees!: any;
  governorates: any[] = [];
  cities: any[] = [];

  isAr = false;
  contentReady = true;
  isCreateOrder = false;

  addressForm!: FormGroup;

  // ===== Google Maps =====
  center: google.maps.LatLngLiteral = { lat: 30.0444, lng: 31.2357 };
  markerPosition: google.maps.LatLngLiteral | null = null;

  markerOptions: google.maps.MarkerOptions = {
    draggable: true,
    icon: {
      url: 'assets/e-commerce/icons/54.webp',
      scaledSize: new google.maps.Size(50, 50),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(25, 50)
    }
  };

  mapOptions: google.maps.MapOptions = {
    disableDefaultUI: true,
    fullscreenControl: true,
    styles: [
      {
        elementType: 'geometry',
        stylers: [{ color: '#f8f5f1' }]
      },
      {
        elementType: 'labels.icon',
        stylers: [{ visibility: 'off' }]
      },
      {
        elementType: 'labels.text.fill',
        stylers: [{ color: '#6f5a43' }]
      },
      {
        elementType: 'labels.text.stroke',
        stylers: [{ color: '#fffaf5' }]
      },
      {
        featureType: 'administrative',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#eadfce' }]
      },
      {
        featureType: 'administrative.land_parcel',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#b7a692' }]
      },
      {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [{ color: '#f3ece3' }]
      },
      {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#8b7763' }]
      },
      {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [{ color: '#eef7ee' }]
      },
      {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#6d8b6d' }]
      },
      {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{ color: '#f0d7ab' }]
      },
      {
        featureType: 'road',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#e7c58f' }]
      },
      {
        featureType: 'road',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#7b6857' }]
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [{ color: '#fc930b' }]
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#d97d08' }]
      },
      {
        featureType: 'road.highway',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#5c4632' }]
      },
      {
        featureType: 'transit',
        elementType: 'geometry',
        stylers: [{ color: '#efe7dc' }]
      },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{ color: '#bfe3f7' }]
      },
      {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#a84e4e' }]
      }
    ]
  };

  private isBrowser: boolean;

  constructor(
    private governoratesService: GovernoratesService,
    private addressesService: UserAddresses,
    public router: Router,
    private location: Location,
    private fb: FormBuilder,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  // ================= INIT =================
  ngOnInit(): void {

    // ⛔ SSR يقف هنا
    if (!this.isBrowser) {
      this.initForm();
      return;
    }

    this.isAr = localStorage.getItem('language') === 'ar';

    this.initForm();
    this.loadGovernorates();

    if (this.router.url === '/Addorderclient') {
      this.isCreateOrder = true;
    }
  }

  // ================= FORM =================
  initForm(): void {
    this.addressForm = this.fb.group({
      address_title: [''],
      address: ['', Validators.required],
      city_id: ['', Validators.required],
      government_id: ['', Validators.required],
      location_link: [''],
      location_latitude: [''],
      location_longitude: [''],
    });
  }

  // ================= GOVERNORATES =================
  loadGovernorates(): void {
    this.contentReady = true;
    this.governoratesService.getAllGovernorates().subscribe({
      next: (data) => {
        this.governorates = data;
        this.contentReady = false;
      },
      error: (err) => {
        console.error(err);
        this.contentReady = false;
      },
    });
  }

  loadCities(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    const governorateId = Number(selectElement.value);

    if (!governorateId) {
      this.cities = [];
      return;
    }

    this.getPrice(governorateId);

    this.governoratesService.getCity(governorateId).subscribe({
      next: (res) => {
        this.cities = res;
        this.contentReady = false;
      },
      error: (err) => {
        console.error(err);
        this.cities = [];
        this.contentReady = false;
      }
    });
  }

  getPrice(id: number): void {
    this.contentReady = true;
    this.governoratesService.getGovernoratePrice(id).subscribe({
      next: (res) => {
        this.deliveryFees = res.price;
        this.fees.emit(this.deliveryFees);
        this.contentReady = false;
      },
      error: (err) => {
        console.error(err);
        this.contentReady = false;
      }
    });
  }

  // ================= MAP =================
  onMapClick(event: google.maps.MapMouseEvent): void {
    if (!this.isBrowser || !event.latLng) return;

    this.markerPosition = {
      lat: event.latLng.lat(),
      lng: event.latLng.lng()
    };
    this.updateLocationLink();
  }

  onMarkerDragEnd(event: google.maps.MapMouseEvent): void {
    if (!this.isBrowser || !event.latLng) return;

    this.markerPosition = {
      lat: event.latLng.lat(),
      lng: event.latLng.lng()
    };
    this.updateLocationLink();
  }

  updateLocationLink(): void {
    if (!this.markerPosition) return;

    const { lat, lng } = this.markerPosition;
    const url = `https://www.google.com/maps?q=${lat},${lng}`;

    this.addressForm.patchValue({
      location_link: url,
      location_latitude: lat,
      location_longitude: lng
    });
  }

  getCurrentLocation(): void {
    if (!this.isBrowser || !navigator.geolocation) {
      Swal.fire({
        icon: 'error',
        title: this.isAr ? 'خطأ' : 'Error',
        text: this.isAr ? 'المتصفح لا يدعم تحديد الموقع' : 'Geolocation not supported',
        confirmButtonText: this.isAr ? 'حسناً' : 'OK',
      });
      return;
    }

    this.contentReady = true;

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;

        this.center = { lat, lng };
        this.markerPosition = { lat, lng };

        this.addressForm.patchValue({
          location_latitude: lat,
          location_longitude: lng,
          location_link: `https://www.google.com/maps?q=${lat},${lng}`
        });

        this.contentReady = false;
      },
      (error) => {
        console.error(error);
        this.contentReady = false;
        Swal.fire({
          icon: 'error',
          title: this.isAr ? 'خطأ' : 'Error',
          text: this.isAr ? 'تعذر الحصول على الموقع الحالي' : 'Unable to get current location',
          confirmButtonText: this.isAr ? 'حسناً' : 'OK',
        });
      }
    );
  }

  // ================= SUBMIT =================
  addAddress(): void {
    if (this.addressForm.invalid) {
      Swal.fire({
        icon: 'error',
        title: this.isAr ? 'خطأ' : 'Error',
        confirmButtonText: this.isAr ? 'حسناً' : 'OK',
        text: this.isAr
          ? 'من فضلك أدخل جميع الحقول المطلوبة'
          : 'Please fill in all required fields'
      });
      return;
    }

    this.contentReady = true;
    const newAddress: Address = this.addressForm.value;

    this.addressesService.createAddress(newAddress).subscribe({
      next: () => {
        this.contentReady = false;
        Swal.fire({
          icon: 'success',
          title: this.isAr ? 'تم' : 'Success',
          confirmButtonText: this.isAr ? 'حسناً' : 'OK',
          text: this.isAr
            ? 'تمت إضافة العنوان بنجاح'
            : 'Address added successfully'
        });
        this.addressForm.reset();
        this.location.back();
      },
      error: (err) => {
        console.error(err);
        this.contentReady = false;
        Swal.fire({
          icon: 'error',
          title: this.isAr ? 'خطأ' : 'Error',
          text: this.isAr
            ? 'حدث خطأ أثناء إضافة العنوان'
            : 'An error occurred while adding the address'
        });
      }
    });
  }
}
